import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICatalogue, PaginateResponse } from '@tacliatech/types';

@Injectable({
  providedIn: 'root',
})
export class CatalogueSearchService {
  constructor(private http: HttpClient) {}

  search(query: { [key: string]: any } = {}) {
    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http.get<PaginateResponse<ICatalogue[]>>(
      `:API_URL/search/customer-catalogue`,
      {
        params,
      }
    );
  }
}
